/** webview类型 */
export const WEBVIEW = {
  /** 澳觅APP */
  APP: 'app',
  /** 微信小程序 */
  WECHAT_MINI_PROGRAM: 'wechatMiniProgram',
  /** 支付宝小程序 */
  ALI_PAY_MINI_PROGRAM: 'aliPayMiniProgram',
  /** 商城H5 */
  H5: 'H5',
}

export const MINI_PROGRAM = [WEBVIEW.ALI_PAY_MINI_PROGRAM, WEBVIEW.WECHAT_MINI_PROGRAM]

export const NEED_SECURITY_AUTHENTICATE = [...MINI_PROGRAM, WEBVIEW.H5]
